import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EarningsEstemateItem } from "../types";
import { loadSecurityEarningsEstimate } from "../thunks/getSecurityEarningsEstimateThunk";

export const useDisplaySecurityEarningsEstimate = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EarningsEstemateItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityEarningsEstimate);

  const displayedStatisticsearningsestimate =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityEarningsEstimate( symbol));
    }
  }, [dispatch, symbol]);

  return displayedStatisticsearningsestimate;
};